<template>
  <div>
    <el-dialog :visible.sync="visible" width="900px" :before-close="() => {this.visible = false}">
      <div class="info">
        <div class="title">{{ $t('common.联系我们') }}</div>
        <div class="con">
          <div class="left">
            <div class="item">
              <img src="~@/assets/common/10.png" >
              <div class="span">
                <span>{{ $t('common.客服电话') }}: {{info.servicePhone}}</span>
                <span>{{ $t('common.工作时间') }}: {{info.workTime}}</span>
              </div>
            </div>
            <div class="item">
              <img src="~@/assets/common/11.png" >
              <div class="span">
                <span>{{ $t('common.官方邮箱') }}: {{info.officialMail}}</span>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="item">
              <img class="ewm" :src="info.weixinQr" >
              <!-- <canvas id="QRCode1" class="ewm" /> -->
              <span>{{ $t('common.扫码添加客服微信') }}</span>
            </div>
            <div class="item">
              <img class="ewm" :src="info.qqQr" >
              <!-- <canvas id="QRCode2" class="ewm" /> -->
              <span>{{ $t('common.扫码添加客服QQ') }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { contactUsDetail } from '@/utils/api'
import QRCode from 'qrcode'
export default {
  name: "agreement",
  components: {QRCode},
  data() {
    return {
      visible: false,
      info: {},
      downloadButton: false,
    };
  },
  methods: {
    init() {
      this.visible = true;
      const that = this
      contactUsDetail().then(res => {
        this.info = res
        
        this.$nextTick(() => {
          var msg1 = document.getElementById('QRCode1')
          QRCode.toCanvas(msg1, res.weixinQr)

          var msg2 = document.getElementById('QRCode2')
          QRCode.toCanvas(msg2, res.qqQr)
        })
      })
    }
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__header{
  padding: 0 !important;
}
/deep/ .el-dialog__body{
  padding: 0 !important;
}
/deep/ .el-dialog__headerbtn .el-dialog__close{
  color: #ffffff !important;
}
.info{
  width: 100%;
  height: 500px;
  background: url('~@/assets/common/9.png') no-repeat;
  background-size: 100% 140px;
  display: flex;
  flex-direction: column;
  .title{
    flex-shrink: 0;
    width: 100%;
    height: 60px;
    font-size: 16px;
    color: #ffffff;
    padding: 0 30px;
    display: flex;
    align-items: center;
  }
  .con{
    flex-grow: 1;
    padding-top: 80px;
    width: 100%;
    display: flex;
    align-items: center;
    .left{
      flex-shrink: 0;
      width: 40%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-left: 50px;
      .item{
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 86px;
        &:last-child{
          margin-bottom: 0;
        }
        img{
          width: 50px;
          height: 50px;
          margin-right: 18px;
        }
        .span{
          height: 50px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          font-size: 14px;
          color: #333333;
        }
      }
    }
    .right{
      flex-grow: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .item{
        flex-shrink: 0;
        width: 150px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 98px;
        &:last-child{
          margin-right: 0;
        }
        .ewm{
          width: 140px;
          height: 140px;
          margin-bottom: 10px;
        }
        span{
          font-size: 14px;
          color: #333333;
        }
      }
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/contactUs.vue